<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
<div class="rr-backdrop" (click)="cancel()">
  <div
    class="rr-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="runner-rename-title"
    tabindex="-1"
    cdkTrapFocus
    (click)="$event.stopPropagation()"
    (keydown.escape)="cancel()"
  >
    <div class="rr-header">
      <div class="rr-icon" aria-hidden="true">
        <mat-icon>drive_file_rename_outline</mat-icon>
      </div>
      <div class="rr-title" id="runner-rename-title">{{ 'runners.rename.title' | translate }}</div>
    </div>

    <label class="rr-label" for="runner-rename-input">{{ 'runners.rename.label' | translate }}</label>
    <input
      #nameInput
      id="runner-rename-input"
      class="rr-input"
      type="text"
      autocomplete="off"
      maxlength="255"
      data-testid="runner-rename-input"
      [class.rr-input--invalid]="error() !== null"
      [value]="name()"
      [readOnly]="saving()"
      [attr.aria-invalid]="error() !== null ? 'true' : null"
      [attr.aria-describedby]="error() !== null ? 'runner-rename-error' : null"
      (input)="onInput($event)"
      (keydown.enter)="onEnter($event)"
    />
    @if (error(); as messageKey) {
      <p class="rr-error" id="runner-rename-error" role="alert" data-testid="runner-rename-error">
        {{ messageKey | translate }}
      </p>
    }

    <div class="rr-actions">
      <button
        mat-stroked-button
        type="button"
        data-testid="runner-rename-cancel"
        [disabled]="saving()"
        (click)="cancel()"
      >
        {{ 'runners.rename.cancel' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        class="rr-save"
        type="button"
        data-testid="runner-rename-save"
        [disabled]="!canSave()"
        (click)="save()"
      >
        @if (saving()) {
          <mat-progress-spinner diameter="16" mode="indeterminate" />
        }
        {{ 'runners.rename.save' | translate }}
      </button>
    </div>
  </div>
</div>
